import { isEmpty } from 'lodash'
import { largeSizes, legendDefault } from '.'
import { defaultExportMenu, getGroupedSeries } from '../helpers'

export default ({ config, data, color, size = 'sm', legendLabels = {} }) => {
  const { labelColor } = color
  const { series, ...restConfig } = config
  const {
    title,
    xKey,
    scrollbar,
    axisRanges,
    disabledAnimations = false,
    exportingMenu,
    removeLegend
  } = restConfig
  const keys = []

  if (!isEmpty(series)) {
    series.forEach((el) => {
      // get custom legend labels with translated values
      !isEmpty(legendLabels) &&
        Object.keys(legendLabels).forEach((key) => {
          if (el.includes(key)) {
            keys.push(legendLabels[key])
          }
        })
    })
  }

  const chartConfig = {
    data: data,
    type: 'XYChart',
    series: getGroupedSeries({
      series,
      otherConfig: {
        color,
        disabledAnimations,
        legendLabel: keys,
        ...restConfig
      }
    }),
    cursor: {},
    scrollbarX: {
      disabled: !scrollbar,
      parent: 'bottomAxesContainer'
    },
    xAxes: [
      {
        type: 'CategoryAxis',
        dataFields: {
          category: xKey
        },
        rangeChangeDuration: 500,
        renderer: {
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          },
          grid: {
            template: {
              strokeWidth: 0,
              fill: labelColor
            }
          },
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          minGridDistance: 60,
          cellStartLocation: 0.1,
          cellEndLocation: 0.7,
          maxLabelPosition: 0.98
        }
      }
    ],
    yAxes: [
      {
        title: {
          text: title || null,
          fill: labelColor,
          fontSize: !largeSizes.includes(size) && 12
        },
        axisRanges: !isEmpty(axisRanges) && [
          {
            value: axisRanges?.value,
            grid: {
              stroke: axisRanges?.color || labelColor,
              strokeWidth: 1,
              strokeOpacity: 1,
              strokeDasharray: axisRanges?.strokeDasharray || 0,
              above: true
            },
            label: {
              text: axisRanges?.text,
              inside: true,
              fill: axisRanges?.textColor || labelColor,
              verticalCenter: 'bottom',
              paddingBottom: 3
            }
          }
        ],
        id: 'CommonYAxis',
        type: 'ValueAxis',
        renderer: {
          line: {
            strokeOpacity: 0.3,
            fill: labelColor
          },
          labels: {
            fill: labelColor,
            fontSize: !largeSizes.includes(size) && 10
          }
        }
      },
      {
        type: 'ValueAxis',
        renderer: {
          opposite: true,
          line: {
            strokeOpacity: 0,
            fill: labelColor
          }
        }
      }
    ],
    legend: legendDefault(labelColor)
  }
  if (removeLegend) {
    delete chartConfig.legend
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      chartConfig.exporting = defaultExportMenu
    } else {
      chartConfig.exporting = exportingMenu.config
    }
  }
  return chartConfig
}
